module.exports = __webpack_public_path__ + "static/media/PhysicalNeuro6dab9666.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/PhysicalNeuro.svg
// module id = 1307
// module chunks = 0